<template>
  <div class="cooperative-agents page-content">
    <section class="module__header">
      <h2 class="module__header__title">合作中介机构</h2>
      <p class="module__header__subtitle">Cooperative intermediaries</p>
    </section>
    <section class="table-list">
      <table class="align-left">
        <colgroup>
          <col style="width: 490px" />
        </colgroup>
        <thead>
          <tr>
            <th>保险中介机构</th>
            <th>合作范围</th>
            <th>合作周期</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="agent in agents" :key="agent.id">
            <td>{{ agent.name }}</td>
            <td>{{ agent.cooperationContent }}</td>
            <td>{{ agent.cooperationBegin }}至{{ agent.cooperationEnd }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="card-list">
      <section class="card" v-for="agent in agents" :key="agent.id">
        <section class="description">
          <span class="label">保险中介机构</span>
          <section class="value">{{ agent.name }}</section>
        </section>
        <section class="description">
          <span class="label">合作范围</span>
          <section class="value">{{ agent.cooperationContent }}</section>
        </section>
        <section class="description">
          <span class="label">合作周期</span>
          <section class="value">
            {{ agent.cooperationBegin }}至{{ agent.cooperationEnd }}
          </section>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import { get } from "lodash";
export default {
  name: "cooperative-agents",
  data() {
    return {
      agents: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/base/insurance-intermediary/pcPageList?pageSize=1000")
        .then((res) => {
          const data = get(res, "data.records");
          if (Array.isArray(data)) {
            this.agents = data;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="less"></style>
